import React, { useState } from 'react';
import {
  Table, Input, InputNumber, Popconfirm, Form, Button
} from 'antd';
import { EditOutlined, SaveFilled, CloseOutlined } from '@ant-design/icons';

const EditableCell = ({
  editing,
  dataIndex,
  title,
  inputType,
  record,
  children,
  ...restProps
}) => {
  let inputNode = inputType === 'number' ? <InputNumber /> : <Input />;



  // CRUFT
  if (title === "Position") {
    inputNode = (
      <select defaultValue={record.position}>
        <option value="lead">LEAD</option>
        <option value="follow">FOLLOW</option>
        <option value="either">EITHER</option>
      </select>
    );
  } else if (title === "Status") {
    inputNode = (
      <select defaultValue={record.paymentStatus}>
        <option value="paid">PAID</option>
        <option value="unpaid">UNPAID</option>
        <option value="waitlisted">WAITLISTED</option>
        <option value="removed">REMOVED</option>
      </select>
    );
  }


  return (
    <td {...restProps}>
      {editing ? (
        <Form.Item
          name={dataIndex}
          style={{
            margin: 0,
          }}
        >
          {inputNode}
        </Form.Item>
      ) : (
        children
      )}
    </td>
  );
};

export default function EditableTable({
  title, data, setData, pagination, columns, onChange, onSave,
}) {
  const [form] = Form.useForm();
  const [editingKey, setEditingKey] = useState('');

  const isEditing = (record) => record.key === editingKey;

  const edit = (record) => {
    const fieldsValue = {};
    columns.filter((col) => col.editable).forEach((col) => { fieldsValue[col.dataIndex] = ''; });
    form.setFieldsValue({
      ...fieldsValue,
      ...record,
    });
    setEditingKey(record.key);
  };

  const save = async (key) => {
    try {
      const row = await form.validateFields();
      const newData = [...data];

      if (key > -1) {
        const item = newData[key];
        newData.splice(key, 1, { ...item, ...row });
        setData(newData);
        setEditingKey('');
      } else {
        newData.push(row);
        setData(newData);
        setEditingKey('');
      }
      if (onSave) { await onSave(data, newData); }
    } catch (errInfo) {
      // console.log('Validate Failed:', errInfo);
    }
  };
  const hasEditable = columns.some((col) => !!col.editable);
  let innerCols;
  if (hasEditable) {
    innerCols = [{
      title,
      dataIndex: 'operation',
      width: '5%',
      render: (_, record) => {
        /* eslint-disable-next-line no-console */
        const editable = isEditing(record);
        return editable ? (
          <span>
            <Button type="link" icon={<CloseOutlined />} onClick={() => setEditingKey('')} />
            <Button type="link" icon={<SaveFilled />} onClick={() => save(record.key)} />
          </span>
        ) : (
          <Button type="link" disabled={editingKey !== ''} icon={<EditOutlined />} onClick={() => edit(record)} />
        );
      },
    }].concat(columns);
  } else {
    innerCols = columns;
  }
  const mergedColumns = innerCols.map((col) => {
    if (!col.editable) {
      return col;
    }

    return {
      ...col,
      onCell: (record) => ({
        record,
        inputType: col.inputType,
        dataIndex: col.dataIndex,
        title: col.title,
        editing: isEditing(record),
      }),
    };
  });
  return (
    <Form form={form} component={false}>
      <Table
        size="small"
        title={!hasEditable ? () => title : undefined}
        components={{
          body: {
            cell: EditableCell,
          },
        }}
        bordered
        dataSource={data.map((r, i) => ({ ...r, key: i }))}
        columns={mergedColumns}
        rowClassName="editable-row"
        pagination={pagination}
        onChange={onChange}
      />
    </Form>
  );
}
